import axios from "axios";
import dotenv from "dotenv";
import {Logs} from "@/utils/Logs";

export default class AppConfig {

  //public static log = new Logs('.env', false);

  public static ENV: string;
  public static API_URL: string;
  public static DARE_ENV: string;
  public static IS_DEBUG: boolean;
  public static IS_TEST_VERSION: boolean;
  public static DARE_VERSION: string;
  public static DARE_GIT_BRANCH: string;
  public static APIM_WFJ_QR_CODE_URL: string;
  public static WFJ_ACTIVE_COUNTRIES: string[] = ['GB', 'AU', 'HK', 'ID', 'KR', 'MY', 'SG', 'TH', 'VN', 'IE', 'MO'];

  public static async init(): Promise<boolean> {
    const buildAppVersion = process.env?.VUE_APP_VERSION ?? 'app-version';
    try {
      const response = await axios.get(`/.env?${encodeURIComponent(buildAppVersion)}`);
      const env = dotenv.parse(response.data);
      AppConfig.ENV = env.NODE_ENV;
      AppConfig.API_URL = env.VUE_APP_PUBLIC_API_URL;
      AppConfig.DARE_ENV = env.VUE_APP_ENV;
      AppConfig.DARE_GIT_BRANCH = env.VUE_APP_VERSION;
      const regex = new RegExp("\\/([0-9\\-\\.]+[0-9])");
      const match = AppConfig.DARE_GIT_BRANCH.match(regex);
      AppConfig.DARE_VERSION = match && typeof match[1] !== 'undefined' ? match[1] : AppConfig.DARE_GIT_BRANCH;
      AppConfig.IS_DEBUG = !['prod'].includes(env.VUE_APP_ENV)
      AppConfig.IS_TEST_VERSION = ['dev', 'int', 'int2', 'uat'].includes(AppConfig.DARE_ENV);
      AppConfig.APIM_WFJ_QR_CODE_URL = env.VUE_APP_APIM_WFJ_QR_CODE_URL;

      Logs.update();

      //AppConfig.log.debug([`retrieving .env : success`, AppConfig.ENV]);
      return true;
    } catch (error) {
      //AppConfig.log.debug([`retrieving .env : error`, error]);
      return false;
    }
  }
}
